import { TableCell, TableRow } from "../../../design/table";
import { Task } from "../../../models/Task";
import { Checkbox } from "../../../design/checkbox";
import { useState } from "react";
import { useTask } from "../../../contexts/TaskContext";
import { Badge } from "../../../design/badge";
import { Link } from "../../../design/link";
import { useTeamMember } from "../../../contexts/TeamMemberContext";
import { TeamMember } from "../../../models/TeamMember";
import { useUser } from "../../../contexts/UserContext";

const TaskTypeBadge: React.FC<{ type: Task["type"] }> = ({ type }) => {
  switch (type) {
    case "evidence":
      return <Badge color="blue">File</Badge>;
    case "event":
      return <Badge color="green">Event</Badge>;
    case "document":
      return <Badge color="purple">Document</Badge>;
    default:
      return <Badge>General</Badge>;
  }
};

interface TaskListItemProps {
  task: Task;
}

const TaskListItem: React.FC<TaskListItemProps> = ({ task }) => {
  const { updateTask } = useTask();
  const { users } = useUser();
  const [isCompleted, setIsCompleted] = useState(task.isCompleted);

  const handleCheckboxChange = (checked: boolean) => {
    setIsCompleted(checked);
    updateTask(task._id, { isCompleted: checked });
  };

  return (
    <TableRow>
      <TableCell style={{ whiteSpace: "pre-line" }}>
        <div className="flex flex-col">
          <Link href={`/task/${task._id}`}>{task.title}</Link>
          <span>
            <TaskTypeBadge type={task.type} />
          </span>
        </div>
      </TableCell>
      <TableCell style={{ whiteSpace: "pre-line" }}>
        {task.assignedToIds
          ?.map((userId) => users.find((u) => u._id === userId)?.name)
          .join(", ")}
      </TableCell>
      <TableCell className="items-center text-right">
        <Checkbox
          checked={isCompleted}
          onChange={handleCheckboxChange}
          className="cursor-pointer"
        />
      </TableCell>
    </TableRow>
  );
};
export default TaskListItem;
